import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

export const logout = async () => {
  const fetchURL = getM8AuthURL('logout');

  const response = await customFetch(fetchURL, { method: 'POST' });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
